
<ul class="hotEntry">
  <li v-for="entry in entries" :key="entry.id" class="hotEntry__entry">
    <div class="hotEntry__entryImage"
         :style="backgroundImage(entry.image_url)"
    >
    </div>
    <div class="hotEntry__entryText">
      <a :href="entry.link" target="_blank" class="hotEntry__entryTitle">
        {{ entry.title.rendered }}
      </a>
      <p v-html="entry.contents" class="hotEntry__entryLead"></p>
    </div>
  </li>
</ul>
